import VueRouter from 'vue-router';
import { installSeo } from './seo';

// Import all pages
import Home from './pages/Home';
import Contact from './pages/Contact';
import Menu from './pages/Menu';
import Catering from './pages/Catering';
import NotFound from './pages/errors/NotFound';

const router = new VueRouter({
 
  routes: [
    {
		path: '/',
		name: 'Home',
		component: Home
	},
	{
		path: '/menu/:brunch?',
		name: 'Menu',
		component: Menu
	},{
		path: '/catering',
		name: 'Catering',
		component: Catering
	},
	{
		path: '/contact',
		name: 'Contact',
		component: Contact
	},
	{
		path: '*',
		name: 'notFound',
		component: NotFound
	},
	{ 
		path: '*', 
		component: NotFound, 
		meta: { notFound: true } 
	}
  ],
  mode: 'history',
  
});

installSeo(router);

// Factory to handle future middleware functionality
function nextFactory(context, middleware, index) {
    const subsequentMiddleware = middleware[index];

    if (!subsequentMiddleware) {
		return context.next;
    } 
  
    return (...parameters) => {
		context.next(...parameters);
		const nextMiddleware = nextFactory(context, middleware, index + 1);
		subsequentMiddleware({ ...context, next: nextMiddleware });
    };
}
  
router.beforeEach((to, from, next) => {
	if (to.meta.middleware) {
		const middleware = Array.isArray(to.meta.middleware) ? to.meta.middleware : [to.meta.middleware];

		const context = {
			from,
			next,
			router,
			to,
		};
		const nextMiddleware = nextFactory(context, middleware, 1);

		return middleware[0]({ ...context, next: nextMiddleware });
	}

	return next();
});

export default router;